import { SvgVM } from './svg.model';

export class ResponseVM {
  [key: string]: string | boolean | SvgVM | undefined;
  key: string;
  value: string | boolean;
  svg?: SvgVM;
  isSelected?: boolean;

  constructor(key: string, value: string | boolean, svg?: SvgVM, isSelected?: boolean) {
    this.key = key;
    this.value = value;
    this.svg = svg;
    this.isSelected = isSelected;
  }
}
